import { FC } from 'react'
import styles from './BrandStory.module.scss'
import SwiperBook from './SwiperBook'

const BrandStory: FC = ({ content }: any) => {
  return (
    <div className={styles.Book}>
      <div className={styles.BookWrapper}>
        <SwiperBook content={content} />
      </div>
    </div>
  )
}

export default BrandStory
